import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Layout from '../../components/Layout/Layout';
import SEO from '../../components/SEO/SEO';
import { getPageContent } from '../../services/dpc';
import ThankYouStyles from './ThankYou.styled';
import Picture from '../../components/Shared/Picture';
import ArrowIcon from '../../components/Shared/ArrowIcon';
import InView from '../../components/Shared/InView';
import SA from '../../styles/Components/SimpleAnimation';
import Error from '../../components/Error/Error';

function ThankYou({
  data: {
    contentCTAs,
    contentVideos,
    faqPod,
    heroCta,
    heroMedia,
    mobileHeroMedia,
    metaDescription,
    preFooterCta,
    tipsAndToolsPod,
    titleTag,
    customerReviewPod,
    disclaimer,
    pageTitle,
    heroText,
  } = {},
  error,
  isLoading,
  className,
}) {
  if (error) {
    console.error(error);
    return (
      <Layout>
        <Error />
      </Layout>
    );
  }

  return (
    <Layout isLoading={isLoading} className={className}>
      <SEO title={titleTag} description={metaDescription} />
      <InView passInViewToChildren={false}>
        <ThankYouStyles>
          <SA.div delay={0.4} className='thank-you-content'>
            <Link className='thank-you-back-link' to='/contractor-enroll/'>
              <ArrowIcon /> Back
            </Link>
            <h1>{pageTitle}</h1>
            <p>{heroText}</p>
          </SA.div>
          <SA.div delay={0.6} shouldSlide={false} className='thank-you-media'>
            <Picture
              src={heroMedia[0]?.media?.fields?.file?.url}
              alt={heroMedia[0]?.media?.fields?.description}
              isResponsive={true}
              sources={[
                { media: '(max-width: 960px)', params: '?w=480' },
                { media: '(max-width: 1150px)', params: '?w=1150' },
                { media: '(min-width: 1150px)', params: '?w=1440' },
                { media: '(min-width: 1440px)', params: '?w=2000' },
              ]}
            />
          </SA.div>
        </ThankYouStyles>
      </InView>
    </Layout>
  );
}

ThankYou.getInitialProps = async ({}) => {
  try {
    const data = await getPageContent('/contractor-enroll/thank-you/');

    if (data.status !== 200) {
      throw data.statusText;
    }

    return {
      data: data.data.result,
    };
  } catch (error) {
    return {
      error,
    };
  }
};

ThankYou.propTypes = {
  match: PropTypes.object,
  history: PropTypes.object,
  location: PropTypes.object,
  data: PropTypes.shape({}),
  error: PropTypes.object,
};

export default ThankYou;
